export default "__VITE_ASSET__45731614__"